import React, { useState } from 'react';
import UnbindApp from './UnbindApp';
import BindApp from './BindApp';

// eslint-disable-next-line react/display-name
export default (props: { client_id: string; isBind: boolean }): JSX.Element => {
  const [isBind, setBind] = useState(props.isBind);
  const { client_id } = props;

  const className = 'rect-button light';

  if (isBind) {
    return <UnbindApp className={className} client_id={client_id} onFinish={() => setBind(false)} />;
  }
  return <BindApp className={className} client_id={client_id} onFinish={() => setBind(true)} btnType="span" />;
};
